export function ZeroLeft(s) {
  var z;
  if (s < 10) z = "0" + s;
  else z = s.toString();
  return z;
}
